import styled from 'styled-components';

const BigH3 = styled.h1`
    font-size: 30px;
    font-weight: 500;
    line-height: 30px;
    color: black;
    text-transform: none;

    @media (max-width: 800px) {
        font-size: 15px;
        line-height: 15px;
    }
`;

export default BigH3;